import { useEffect } from 'react';
import loadDependentScripts from '../../utils/loadDependentScripts';
import ErrorBoundary from '../../components/ErrorBoundary';
import GlobalToolbar from '../../components/GlobalToolbar/GlobalToolbar';
import { NavigationComponentsProvider } from '../../components/NavigationComponentsProvider';
import { useLoadHelpCta } from '../../external-contrib/in-app-help/hooks/useLoadHelpCta';
import { useAppDispatch } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export const FallbackNav = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    loadDependentScripts([]);
  }, [dispatch]);
  useLoadHelpCta(false);
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: "Navigation - Fallback Nav",
    children: /*#__PURE__*/_jsx(NavigationComponentsProvider, {
      children: /*#__PURE__*/_jsx(GlobalToolbar, {})
    })
  });
};
export default FallbackNav;